// extracted by mini-css-extract-plugin
export var cell = "productCard-module--cell--xsLFa";